export const navLinks = [
  {
    label: 'Projects',
    pathname: '/',
    hash: '#project-1',
  },
  {
    label: 'Articles',
    pathname: '/articles',
  },
  {
    label: 'About',
    pathname: '/',
    hash: '#about',
  },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/aditya-kumar-b99b1519b/',
    icon: 'linkedin',
  },
  {
    label: 'Github',
    url: 'https://github.com/inductor69',
    icon: 'github',
  },
  {
    label: 'Email',
    url: 'mailto:adityakiitdelhi@gmail.com',
    icon: 'email',
  },
];
